export default "__VITE_ASSET__89ff3d4e__"